import { useCallback, useState } from 'react';
import Flex from '@creditflowresearch/uilib/Flex';
import Button from '@creditflowresearch/uilib/Button';
import {
  useBondScreenerViewsContext,
} from '@/creditflowresearch/application/BondScreener/Sidebar/BondScreenerViewsContext';
import {
  BondScreenerRenameViewModal,
} from '@/creditflowresearch/ui/common/components/molecules/BondScreenerRenameViewModal';
import {
  BondScreenerDeleteViewModal,
} from '@/creditflowresearch/ui/common/components/molecules/BondScreenerDeleteViewModal';
import LoginOrSignUpPopover from '@/creditflowresearch/ui/common/components/LoginOrSignUpPopover';

import styles from './viewActions.module.scss';

interface IViewActionsProps {
  resetDataTest: string,
  isRestricted?: boolean,
}

export const ViewActions = ({ resetDataTest, isRestricted = false }: IViewActionsProps) => {
  const { views, activeView, selectView, renameActiveView, deleteActiveView } = useBondScreenerViewsContext();
  const [isRenameModalVisible, setIsRenameModalVisible] = useState(false);
  const [isDeleteConfirmVisible, setIsDeleteConfirmVisible] = useState(false);

  const handleReset = useCallback((): void => {
    selectView(null);
  }, [selectView]);

  const handleRename = useCallback((name: string): void => {
    setIsRenameModalVisible(false);
    renameActiveView(name);
  }, [renameActiveView]);

  const handleDelete = useCallback((): void => {
    setIsDeleteConfirmVisible(false);
    deleteActiveView();
  }, [deleteActiveView]);

  return (
    <>
      <Flex gap={ 20 } align="center">
        <Button
          variant="text"
          size="S"
          onClick={ handleReset }
          className={ styles.resetButton }
          dataTest={ resetDataTest }
        >
          Reset
        </Button>
        <LoginOrSignUpPopover isRestricted={ isRestricted }>
          <Button
            variant="text"
            size="S"
            disabled={ isRestricted || !activeView }
            onClick={ () => setIsRenameModalVisible(true) }
            className={ styles.renameButton }
            dataTest="renameViewButton"
          >
            Rename
          </Button>
        </LoginOrSignUpPopover>
        <LoginOrSignUpPopover isRestricted={ isRestricted }>
          <BondScreenerDeleteViewModal
            isVisible={ isDeleteConfirmVisible }
            onVisibleChange={ setIsDeleteConfirmVisible }
            onConfirm={ handleDelete }
            dataTest="deleteViewModal"
            disabled={ isRestricted || !activeView }
          >
            <Button
              variant="text"
              size="S"
              disabled={ isRestricted || !activeView }
              className={ styles.deleteButton }
              dataTest="deleteViewButton"
            >
              Delete
            </Button>
          </BondScreenerDeleteViewModal>
        </LoginOrSignUpPopover>
      </Flex>
      <BondScreenerRenameViewModal
        isVisible={ isRenameModalVisible }
        existingNames={ views.filter((view) => view.id !== activeView?.id).map((view) => view.name) }
        initialName={ activeView?.name ?? '' }
        onRename={ handleRename }
        onCancel={ () => setIsRenameModalVisible(false) }
      />
    </>
  );
};
